"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Notification = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Notification = ({
  className,
  message,
  variant,
  remixIconClasses,
  close,
  ...rest
}) => {
  const [showNotification, setshowNotification] = (0, _react.useState)(true);
  let baseClass = showNotification ? "sp-notification" : "sp-notification--hide";
  let classes = (0, _classnames.default)(className, `${baseClass}`, `${baseClass}--${variant}`);

  const closeNotification = () => {
    setshowNotification(close ? close : false);
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: "sp-notification--icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: remixIconClasses
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "sp-notification--message"
  }, message), /*#__PURE__*/_react.default.createElement("span", {
    className: "sp-notification--close",
    onClick: () => close ? close : closeNotification()
  }, "\u2715"));
};

exports.Notification = Notification;
Notification.defaultProps = {
  variant: "success",
  remixIconClasses: "ri-checkbox-circle-fill"
};
Notification.propTypes = {
  className: _propTypes.default.string,
  close: _propTypes.default.bool,
  message: _propTypes.default.string.isRequired,
  variant: _propTypes.default.string,
  remixIconClasses: _propTypes.default.string
};
var _default = Notification;
exports.default = _default;